/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect, act } from 'react';
import { useLocation, useNavigate, useHistory } from 'react-router-dom';
import Navigation from '../../components/navigation';
import LoginForm from '../../components/LoginForm';
import AlgorithmImg from "../../background/algorithm.png";
import AlgorithmImg2 from "../../background/algorithm2.png";
import { useContext } from "react";
import ApiService from '../../services/ApiService';
import WindowSizeContext from '../../utils/WindowSizeContext';
import "./styles.css"

function Description(props) {
  const navigate = useNavigate();
  const { state } = useLocation();
  const size = useContext(WindowSizeContext);
  let num = (props.type ? props.type : (state.num ? state.num : 1))
  const [active, setActive] = useState(num)
  const [loginForm, setLoginForm] = useState(false);

  useEffect(() => {
    size.width < 751 ? openBlock(active) : openFullBlock(active)
    //eslint-disable-next-line
  }, [])

  useEffect(() => {
    ApiService.userinfo().then((response) => {
      props.setUser(response.user);
    });
    //eslint-disable-next-line
  }, []);

  function useWindowSize() {
    const [windowSize, setWindowSize] = useState({
      width: window.innerWidth,
      height: window.innerHeight,
      maxHeight: Math.max(window.innerHeight - 55, Math.floor(window.innerHeight / 100 * 93))
    });
    useEffect(() => {
      setActive(active)
      window.innerWidth < 751 ? openBlock(active) : openFullBlock(active)
    }, [windowSize])
    useEffect(() => {
      function handleResize() {
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
          maxHeight: Math.max(window.innerHeight - 55, Math.floor(window.innerHeight / 100 * 93))
        });

      }
      window.addEventListener("resize", handleResize);
      handleResize();
      return () => window.removeEventListener("resize", handleResize);
    }, []);
    return windowSize;
  }

  function textOfArticle(num, id, full, height) {
    switch (num) {
      case 1:
        return <div id={id ? id : ''} className='textContainer whatText' style={{ height: height ? height : 'unset' }}>

          <h4 className='textH4'>Что такое «робот-картограф» и почему так пафосно называется?</h4>
          <p className="descriptionText">
            Наша технология, которая автоматически объединяет множество картографических и адресных источников, чтобы получить подробное описание здания или сооружения - его «цифровой профиль». На основе такого описания, гораздо более полного, чем используемое в обычных цифровых картах, можно решать множество аналитических задач.
            А название – ну, так захотели. Ну и правда немного похоже на робота, который «обходит» все доступные ресурсы, собирает оттуда данные и конструирует карту.
          </p>

          <h4 className='textH4'>А в чем проблема?</h4>
          <p className="descriptionText">
            Основная проблема - у нас в стране, к сожалению, нет единого источника достоверной информации о координатах (положении), адресах и других характеристик зданий. Но даже если такая «суперточная» карта появится, то изменений в жизни так много и они такие быстрые, что любая карта довольно быстро устареет, надо постоянно отслеживать и вносить изменения. Ну и это очень сильно мешает использовать геоданные в обработке bigdata, в анализе недвижимости, налоговых начислений, при геомаркетинге и массе других приложений.
          </p>

          <h4 className='textH4'>Объясните на пальцах, в чем основная идея? </h4>
          <p className="descriptionText minBottomMargin">
            Не все так плохо - есть много-много «почти правильных» источников, хотя каждый не до конца достоверный. Остается научиться их хорошо «склеивать» между собой, чтобы повысить достоверность и полноту информации.
            То есть используется «принцип википедии» – если несколько независимых источников говорят, что здесь дом «Третья улица строителей, 25», то, скорее всего, так оно и есть.
          </p>
          <p className="descriptionText zeroTopMargin">
            Подробнее в разделе &#160;
            <a className='linkText' onClick={() => {
              size.width < 751 ? openBlock(3) : openFullBlock(3)
              setActive(3)
            }}>"Kак это работает?"</a>
          </p>

          <h4 className='textH4'>И вы сделали это на всю страну? </h4>
          <p className="descriptionText">
            По всем городам России с населением свыше 100 тысяч жителей, некоторые регионы обработаны полностью, некоторые частично. Лучше всего смотреть на результат в Самарской области, где использовалось более 10 источников. Для большинства остальных регионов пока это демонстрационный материал на ограниченном наборе источников, но мы постоянно их дополняем и повышаем качество результата.
          </p>

          <h4 className='textH4'>Kак я могу это использовать?</h4>
          <p className="descriptionText zeroBottomMargin">
            Зависит от того, что у вас есть и что вы хотите:
          </p>
          <ul className='ulBlock'>
            <li>
              У Вас есть набор данных (датасет) с адресами или координатами, и вы его хотите «обогатить», то есть дополнить дополнительными характеристиками или просто геокодировать, превратить в цифровую карту – велкам, с помощью личного кабинета.
            </li>
            <li>
              Вы хотите решить прикладную задачу, но у вас нет данных – посмотрите какие можно решать задачи, какие выгрузить датасеты.
            </li>
            <li>
              У вас есть программное обеспечение, но не хватает функциональности – используйте программный интерфейс API Робота-Картографа.
            </li>
            <li>
              У вас есть адресный план города, но он либо устаревший, либо вы хотите его «проверить» на то, все ли объекты в него внесены. Напишите <a href="mailto:team@geosamara.ru">team@geosamara.ru</a>, пришлите его нам, мы его включим в состав источников и выгрузим вам «разницу».
            </li>
            <li>
              У Вас нет ничего, но есть желание сделать что-то хорошее. Можете написать нам и помочь в части уточнения и сбора данных.
            </li>
          </ul>
          <p className="descriptionText zeroTopMargin">
            Подробнее в разделе &#160;
            <a className='linkText' onClick={() => {
              size.width < 751 ? openBlock(2) : openFullBlock(2)
              setActive(2)
            }}>"Зачем это?"</a>
          </p>

          <h4 className='textH4'>И все же – чем это отличается от картографиченских источников, например, от Яндекс.Карт или OpenStreetMap?</h4>
          <p className="descriptionText  minBottomMargin">
            От всех них – составом данных по зданиям и расширенными возможностями для анализа. Ну и ориентацией на обработку именно «больших» наборов данных. Для нас чем больше пользовательских данных будет проходить через систему, тем лучше, соответственно, так и построены лицензии.
          </p>
          <p className="descriptionText  zeroTopMargin minBottomMargin">
            Кроме того, от проприетарных сервисов типа Яндекс.Карт – возможностью выгрузки данных, использования в своих приложениях, а не только внутри платформы.
          </p>

          <h4 className='textH4'>Как мне проще всего посмотреть, с чего начать?</h4>
          <p className="descriptionText minBottomMargin">
            Открыть карту, включить слой «Объединенный адресный план» (ОАП) или тематические раскраски по нему и пощелкать по зданиям, посмотреть связи и характеристики.
          </p>
          <p className="descriptionText zeroTopMargin">
            А еще лучше – &#160;
            <a className='linkText' onClick={() => { window.open('https://rk.geosamara.ru/user/?returnTo=' + encodeURIComponent('/lk/'), '_blank') }}>зарегистрироваться</a> &#160;
            на сайте, и вам будет доступен личный кабинет, где вы можете загрузить свои датасеты, создать тематические слои и вести обработку.
          </p>

        </div>
      case 2:
        return <div id={id ? id : ''} className='textContainer whyText' style={{ height: height ? height : 'unset' }}>
          <h4 className='textH4'>Проще всего перечислить конкретные задачи (кейсы) которые можно решать с помощью продукта. </h4>
          <p className="descriptionText minBottomMargin">
            Нам надо создать карту объектов культурного наследия (как пример)
          </p>
          <ul className='ulBlock zeroTopMargin'>
            <li>
              Берете перечень ОКН с адресами с сайта управления охраны
            </li>
            <li>
              Загружаете в личный кабинет, геокодируете.
            </li>
            <li>
              Смотрите и выгружаете карту.
            </li>
          </ul>

          <h4 className='textH4'>Мы - организация, обслуживающая население на некоторой территории, заключаем абонентские договора (например, на вывоз отходов). Хотим найти, а где у нас резерв, кто не заключил договора?
          </h4>
          <ul className='ulBlock zeroTopMargin'>
            <li>
              Загружаете свой список адресов абонентов
            </li>
            <li>
              Связываете с ОАП
            </li>
            <li>
              Фильтруете датасет из разницы между ОАП и списком ваших абонентов, дополняете его полем «количество жителей», отфильтровываете нежилые дома
            </li>
            <li>
              Экспортируете как эксель или GeoJSON, раздаете своим сотрудникам
            </li>
          </ul>

          <h4 className='textH4'>У нас в городе есть старый адресный план, как его быстро обновить?</h4>
          <p className="descriptionText  minBottomMargin">
            Тут можно поступить, связав «через личный кабинет» по адресу, но гораздо лучше обратиться к нам – мы включим ваш адресный план в схему связей и через несколько дней пересчитаем ОАП по вашему городу, это будет более правильно. В тематических картах на сайте можно посмотреть такие примеры (слой «Старые адресные планы») для Пензы, Казани, Самары и Москвы.
          </p>
          <p className="descriptionText  zeroTopMargin">
            После этого можно через личный кабинет получить датасеты расхождений: объекты, которые рекомендуется добавить, объекты, которые не находятся в других источниках, объекты, получившие исправленные значения адресов и других характеристик, ну и куча всего дополнительно.
          </p>

          <h4 className='textH4'>А если адресного плана вообще нет, нужно его создать?</h4>
          <p className="descriptionText">
            Надо получить текущую версию ОАП и «дорисовать» контура объектов там, где система рекомендует. Можно обратиться к нам, мы поможем.
          </p>

          <h4 className='textH4'>Как получить карту населения «с точностью до дома»?</h4>
          <p className="descriptionText">
            Это сделано внутри системы в виде готового набора. Если в источниках есть количество жителей, и оно удовлетворяет критериям типа «в гараже не может быть 200 человек» - берется из источника. Иначе – рассчитывается по количеству квартир, иначе – по площади и количеству этажей и т.д. Точность – не хуже 5% для многоэтажных домов.
          </p>

          <h4 className='textH4'>Мы занимаемся транспортным и градостроительным планированием. Как нам получить карты социальных объектов (школы, больницы, детские сады)?</h4>
          <p className="descriptionText">
            Это уже есть в готовых наборах данных как «побочный» продукт создания ОАП.
          </p>

          <h4 className='textH4'>Как мне определить, сколько у нас незарегистрированных ИЖС (или иных объектов недвижимости) и какие? </h4>
          <p className="descriptionText">
            Для Самарской области мы вполне успешно решили эту задачу. Были подключен ОАП, информация от ресурсоснабжающих организаций, кадастровые данные о зарегистрированных объектах и «разница» между ними – незарегистрированные ИЖС, которых нашлось около 40 тысяч. Планомерная работа чиновников из муниципальных образований в течение года – и на сегодня из них зарегистрировано около 10 тысяч объектов, а это около 60 млн.руб в год дополнительных налогов.
          </p>

          <h4 className='textH4'>Можно использовать Ваше геокодирование по адресу в своей системе?</h4>
          <p className="descriptionText">
            Да, в Самарской области порядка 10 внешних систем сейчас геокодируют свои данные по адресу на нашем геопортале. Обратитесь, у нас есть API.
          </p>

          <h4 className='textH4'>А можно мне…</h4>
          <p className="descriptionText minBottomMargin">
            Конечно это не полный перечень вариантов использования. Но в целом, все они крутятся вокруг «арифметики» на данных. «Сложение» - когда мы к одному массиву данных (в том числе вашему) быстро добавили другой массив (объединенный адресный план) и получили новое качество. «Вычитание» - когда мы посчитали разницу между двумя массивами данных  и получили «несходилки» - или какой-то дефект в данных, который интересен для анализа, или произошедшие изменения.
          </p>

          <p className="descriptionText zeroTopMargin">
            Звоните, пишите на &#160; <a href="mailto:team@geosamara.ru">team@geosamara.ru</a> !
          </p>

        </div>
      case 3:
        return <div id={id ? id : ''} className='textContainer howText' style={{ height: height ? height : 'unset' }}>
          <h4 className='textH4'>Ну и как это работает?</h4>
          <ul className='ulBlock zeroTopMargin'>
            <li>
              «добываются» и импортируются данные из источников;
            </li>
            <li>
              данные нормализуются (например, стандартизируется запись адреса, устраняются выбросы);
            </li>
            <li>
              устанавливаются связи между похожими объектами, находятся сильно связанные компоненты – «кластеры», по ним строятся объекты ОАП, лишенные противоречий;
            </li>
            <li>
              по специальным алгоритмам и моделям вычисляются неявные характеристики – типы зданий, количество жилых помещений и жителей, доступность различных видов организаций, транспортная доступность;
            </li>
            <li>
              данные публикуются на карту, обновляется объединенный адресный план, все тематические наборы и слои на его основе.
            </li>
          </ul>

          <h4 className='textH4'>Вот ниже это все на схеме: </h4>
          <img src={size.width > 750 ? AlgorithmImg : AlgorithmImg2} className="illustration minBottomMargin" alt='AlgorithmImg' />

          <h4 className='textH4'>Какие источники используются?</h4>
          <p className="descriptionText zeroBottomMargin">
            Про все говорить не будем, перечислим несколько
          </p>
          <ul className='ulBlock zeroTopMargin'>
            <li>
              результаты распознавания аэрофото- и космоснимков;
            </li>
            <li>
              государственный адресный реестр, ГАР, ранее известный как ФИАС;
            </li>
            <li>
              ГИС ЖКХ, где есть информация об адресах многоквартирных домов, их характеристиках;
            </li>
            <li>
              ГАС «Выборы», где мы получаем информацию о домах, в которых проживают избиратели;
            </li>
            <li>
              кадастровые данные о земельных участках и ОКС, полученные с сайта РосРеестра (да, если покопаться, они там есть, но не всегда свежие и не на все регионы).
            </li>
            <li>
              региональные данные от органов власти (адресные планы, различные списки адресов тематических объектов);
            </li>
            <li>
              OpenStreetMap и иные справочные картографические ресурсы.
            </li>
          </ul>

          <h4 className='textH4'>А что за техническая проблема – найти и объединить эти данные? Взять какую-нибудь карту типа OpenStreetMaps, по адресам прикрепить к нему все остальное?</h4>
          <p className="descriptionText">
            Оооо! Контура могут сильно отличаться, не говоря уже о написаниях адреса. «Третья улица строителей», «3-я ул. строителей», «Третья строителей, Лукашинского района», кроме того перепутаны литеры, иногда и номера домов, источники неполные, особенно в «частном секторе». Как показывает наша многолетняя практика, такое решение «в лоб» дает результат только 60-70 процентов.
            Поэтому используется «нечеткое» установление соответствия с расчетом метрики – «степени уверенности». И вот на этом графе «нечеткого соответствия» выбираются лучшие кластеры  по совокупной метрике связи. Качество намного возрастает.
          </p>

          <h4 className='textH4'>А что, неужели это все не может сделать ГИС-специалист (специалист по анализу геоданных)?</h4>
          <p className="descriptionText">
            Ну, во-первых, у нас в стране их немного, хотя они хорошие. Во-вторых, один раз сможет, да и делают.  Разработка практически любого генплана или подобного документа начинается со сбора и анализа данных, выполняемых специалистами. Вопрос во времени, а главное – в возможности делать это постоянно, отлавливать все изменения. «Руками» это сделать довольно тяжело.
          </p>

          <h4 className='textH4'>Что доступно для пользователя?</h4>
          <ul className='ulBlock zeroTopMargin'>
            <li>
              Загрузить свой набор данных из экселя или GeoJSON
            </li>
            <li>
              Провести предобработку – разобрать адрес, нормализовать адресную часть, причесать геометрию, уточнить структуру полей, их назначение.
            </li>
            <li>
              Связать набор с ОАП, тем самым обогатить и геокодировать </li>
            <li>
              Работать с набором, как с интерактивной таблицей в браузере, делать различные тематические выборки, редактировать данные
            </li>
            <li>
              Выгрузить весь набор или тематические выборки в обменные файлы (эксель или GeoJSON)
            </li>
            <li>
              Опубликовать набор в виде слоя на интерактивной карте
            </li>
            <li>
              Встроить карту в свой сайт или приложение, добавить ему функциональности за счет интеграции с API Робота-Картографа
            </li>
          </ul>
        </div>

      default:
        break;
    }
  }

  function openFullBlock(number) {
    let maxBlockHeight = size.height - 160
    let containerText1 = document.getElementById('firstBlock')
    let containerText2 = document.getElementById('secondBlock')
    let containerText3 = document.getElementById('thirdBlock')
    if (containerText1 && containerText2 && containerText3)
      switch (number) {
        case 1:
          containerText1.style.height = `${maxBlockHeight}px`
          containerText1.style.maxHeight = `${maxBlockHeight}px`
          containerText2.style.height = 0
          containerText2.style.maxHeight = 0
          containerText3.style.height = 0
          containerText3.style.maxHeight = 0
          break;
        case 2:
          containerText1.style.height = 0
          containerText1.style.maxHeight = 0
          containerText2.style.height = `${maxBlockHeight}px`
          containerText2.style.maxHeight = `${maxBlockHeight}px`
          containerText3.style.height = 0
          containerText3.style.maxHeight = 0
          break;
        case 3:
          containerText1.style.height = 0
          containerText1.style.maxHeight = 0
          containerText2.style.height = 0
          containerText2.style.maxHeight = 0
          containerText3.style.height = `${maxBlockHeight}px`
          containerText3.style.maxHeight = `${maxBlockHeight}px`
          break;
        default:
          break;
      }
  }

  function openBlock(number) {
    let containerText1 = document.getElementById('firstBlock')
    let containerText2 = document.getElementById('secondBlock')
    let containerText3 = document.getElementById('thirdBlock')
    let container1 = document.getElementById('descriptionCont1')
    let container2 = document.getElementById('descriptionCont2')
    let container3 = document.getElementById('descriptionCont3')
    let headerDiv1 = document.getElementById('headerDiv1')
    let headerDiv2 = document.getElementById('headerDiv2')
    let headerDiv3 = document.getElementById('headerDiv3')

    if (container1 && container2 && container3 && containerText1 && containerText2 && containerText3 && headerDiv1 && headerDiv2 && headerDiv3) {

      headerDiv1.style.minHeight = size.maxHeight / 100 * 7 + 'px'
      headerDiv2.style.minHeight = size.maxHeight / 100 * 7 + 'px'
      headerDiv3.style.minHeight = size.maxHeight / 100 * 7 + 'px'
      let prs2 = size.maxHeight / 100 * 2
      container1.style.padding = prs2 + 'px ' + prs2 + 'px ' + 0 + ' ' + prs2 + 'px'
      container2.style.padding = prs2 + 'px ' + prs2 + 'px ' + 0 + ' ' + prs2 + 'px'
      container3.style.padding = prs2 + 'px ' + prs2 + 'px ' + 0 + ' ' + prs2 + 'px'

      containerText2.style.margin = 0 + ' ' + 0 + ' ' + size.maxHeight / 100 * 9 + 'px ' + 0;
      containerText3.style.margin = 0 + ' ' + 0 + ' ' + size.maxHeight / 100 * 2 + 'px ' + 0;

      switch (number) {
        case 1:
          containerText1.style.maxHeight = `${containerText1.scrollHeight}px`
          containerText2.style.maxHeight = 0
          containerText3.style.maxHeight = 0
          container1.style.height = size.maxHeight / 100 * 84 + 'px'
          container2.style.height = size.maxHeight / 100 * 18 + 'px'
          container3.style.height = size.maxHeight / 100 * 9 + 'px'
          break;
        case 2:
          containerText1.style.maxHeight = `${containerText1.scrollHeight}px`
          containerText2.style.maxHeight = `${containerText2.scrollHeight}px`
          containerText3.style.maxHeight = 0
          container1.style.height = size.maxHeight / 100 * 84 + 'px'
          container2.style.height = size.maxHeight / 100 * 91 + 'px'
          container3.style.height = size.maxHeight / 100 * 9 + 'px'
          break;
        case 3:
          containerText1.style.maxHeight = `${containerText1.scrollHeight}px`
          containerText2.style.maxHeight = `${containerText2.scrollHeight}px`
          containerText3.style.maxHeight = `${containerText3.scrollHeight}px`
          container1.style.height = size.maxHeight / 100 * 84 + 'px'
          container2.style.height = size.maxHeight / 100 * 91 + 'px'
          container3.style.height = size.maxHeight / 100 * 82 + 'px'
          break;
        default:
          break;
      }
    }
  }


  useEffect(() => {
    let newPath = '/';
    switch (active) {
      case 1:
        newPath += 'what'
        break;
      case 2:
        newPath += 'why'
        break;
      case 3:
        newPath += 'how'
        break;
      default:
        newPath += 'what'
        break;
    }
    navigate(newPath);
    //eslint-disable-next-line
  }, [active]);


  return (
    <>
      <Navigation
        showLoginForm={() => { setLoginForm(!loginForm); }}
        afterLogout={() => {
          ApiService.userinfo().then((response) => {
            props.setUser(response.user)
          });
        }}
        user={props.user}
        isLoginShow={loginForm}
      />
      {loginForm &&
        <LoginForm
          afterLogin={() => {
            ApiService.userinfo().then((response) => {
              props.setUser(response.user)
              navigate('/lk/MyDatasets')
            });
            setLoginForm(false);
          }}
        />
      }
      <div className="Information">
        <div id='descriptionContainer' className='descriptionContainer' style={{ height: size.maxHeight }}>
          {size.width > 750 &&
            <>
              <div className='descriptionNav'>
                <h2 className={"headerText" + (active === 1 ? " activeDescription" : '')} onClick={() => {
                  setActive(1)
                  openFullBlock(1)
                }}>Что это? </h2>
                <h2 className={"headerText" + (active === 2 ? " activeDescription" : '')} onClick={() => {
                  setActive(2)
                  openFullBlock(2)
                }}>Зачем? </h2>
                <h2 className={"headerText" + (active === 3 ? " activeDescription" : '')} onClick={() => {
                  setActive(3)
                  openFullBlock(3)
                }}>Как работает? </h2>
              </div>
              {textOfArticle(active, 'firstBlock', true, size.maxHeight - 110)}
              {textOfArticle(active, 'secondBlock', true, size.maxHeight - 110)}
              {textOfArticle(active, 'thirdBlock', true, size.maxHeight - 110)}
            </>
          }

          {size.width < 751 && <>
            <div id='descriptionCont1' className='descriptionNav first'>
              <div id='headerDiv1' className={"headerText" + (active === 1 ? " activeDescription" : '')} onClick={() => {
                openBlock(1);
                setActive(1)
              }}>Что это? </div>
              {textOfArticle(1, 'firstBlock')}
            </div>
            <div id='descriptionCont2' className='descriptionNav second'>
              <h2 id='headerDiv2' className={"headerText" + (active === 2 ? " activeDescription" : '')} onClick={() => {
                openBlock(2)
                setActive(2)
              }}>Зачем? </h2>
              {textOfArticle(2, 'secondBlock')}
            </div>
            <div id='descriptionCont3' className='descriptionNav third'>
              <h2 id='headerDiv3' className={"headerText" + (active === 3 ? " activeDescription" : '')} onClick={() => {
                openBlock(3)
                setActive(3)
              }}>Как работает? </h2>
              {textOfArticle(3, 'thirdBlock')}
            </div>
          </>
          }

        </div>
      </div>
    </>);
}

export default Description;